import { createModule } from '../../createModule';
export const createLogsAPI = createModule(({ http }) => ({
    getScheduledTasks: async () => {
        const res = await http.get('/v2/logs/scheduled-tasks');
        return res;
    },
    getDatahandlerQueries: async () => {
        const res = await http.get('/v2/logs/datahandler-queries');
        return res;
    },
    getSteppedTasks: async () => {
        const res = await http.get('/v2/logs/stepped-tasks');
        return res;
    },
}));
